"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeFreeProducts = exports.getThresholdAmountFromCriteria = exports.isMetThresholdCriteriaExactly = exports.isMetThresholdCriteria = exports.calculateDiscountableAmount = exports.getMultiplierByPromotionCriteriaAndDividend = exports.getPromotionCriteriaByPromotionSetting = exports.validatePromotionCriteria = exports.sortedPromotionCriteria = exports.getPromotionDiscountCriteria = exports.getPromotionThreshold = exports.getLargestDimension = exports.hasBothDigitalAndSKUProducts = exports.hasOnlyXTypeProducts = exports.hasAllXTypeProductSKUs = exports.hasSomeXTypeProductSKUs = exports.filterDuplicatedPromotionsByPromotionSettingsType = exports.getHighestPriorityPromotionByPromotionSettingsType = exports.getNumberInRange = exports.sortPromotionsByPriorityFromHightToLow = exports.calculateDiscount = exports.getSerializeOrderProducts = exports.getSerializeCartProducts = exports.getTotalSelectedOptionsPrice = exports.sortPromotionsForApplyToCart = exports.sortPromotionByPromotionPriority = exports.sortCartByAwardFromLowToHigh = exports.separateShippingPromotionsAndOtherPromotions = exports.separateFreeablePromotionsAndOtherPromotions = exports.mergeProductSKUsInformation = exports.getShippingRulesOfProductSKUs = exports.getUniqueShippingRulesByShippingId = exports.getUniqueShippingRules = exports.getTotalPriceIncludingDiscountOfSelectedProducts = exports.getTotalPriceOfSelectedProducts = exports.getTotalWeight = exports.getTotalPrice = exports.getTotalAmountOfSelectedProducts = exports.getTotalAmount = exports.getSelectedProductsWithSelectedProductIdsAndPromotionIds = exports.getRemainingProductSKU = exports.getFloatValueWithFixedDigit = exports.getAmountThresholdForUnitPriceShippingRule = exports.isEveryProductSKUHasShippingRules = exports.hasShippingRuleInEveryProductSKUs = exports.hasShippingRuleInEveryProductSKUsBySelectedShippingId = exports.hasSomeSelectedProductsInProductSKUs = exports.hasSomeFreeProductsToGiveaway = exports.parseFloatNumberWithDefaultDigit = exports.isNotNullAndUndefined = void 0;
exports.getMaximumShippingDuration = exports.isMatchedSelectedShippingByChosenShippingMethod = exports.isMatchedSelectedShippingByChosenShippingIdsAndSelectedShippingId = exports.getLargestProductSKU = void 0;
const lodash_uniqby_1 = __importDefault(require("lodash.uniqby"));
const errors_1 = require("../errors");
const typings_1 = require("../typings");
const FREEABLE_PROMOTIONS = [typings_1.PromotionSettingsType.BUY_X_GET_Y, typings_1.PromotionSettingsType.FREE_GIVEAWAY];
/**
 * Check whether given value is not "null"
 * and "undefined"
 * @param value
 * @returns {boolean} isNotNullAndUndefined
 */
function isNotNullAndUndefined(value) {
    return value !== undefined && value !== null;
}
exports.isNotNullAndUndefined = isNotNullAndUndefined;
function isUndefined(value) {
    return value === undefined;
}
function parseFloatNumberWithDefaultDigit(price, digit = 2) {
    return parseFloat(price.toFixed(digit));
}
exports.parseFloatNumberWithDefaultDigit = parseFloatNumberWithDefaultDigit;
function hasSomeFreeProductsToGiveaway(freeProducts) {
    const giveawayAbleAmount = freeProducts.map((freeProduct) => freeProduct.stock - freeProduct.amount);
    return giveawayAbleAmount.some((giveawayAmount) => giveawayAmount >= 0);
}
exports.hasSomeFreeProductsToGiveaway = hasSomeFreeProductsToGiveaway;
function hasSomeSelectedProductsInProductSKUs(productSKUs, selectedProductIds) {
    return productSKUs.some((productSKU) => selectedProductIds.includes(productSKU.id));
}
exports.hasSomeSelectedProductsInProductSKUs = hasSomeSelectedProductsInProductSKUs;
/**
 * Has shipping rule in every product skus by selected shipping id
 * This will compare selected shipping id with chosen shipping ids
 * that is in shipping rule information itself
 */
function hasShippingRuleInEveryProductSKUsBySelectedShippingId(productSKUs, shippingRules, selectedShippingId) {
    const productSKUIdsOfShippingRules = shippingRules
        .filter((shippingRule) => { var _a; return (_a = shippingRule.shippingIds) === null || _a === void 0 ? void 0 : _a.includes(selectedShippingId); })
        .flatMap((shippingRule) => shippingRule.selectedProducts.map((selectedProduct) => selectedProduct.id));
    return productSKUs.every((productSKU) => productSKUIdsOfShippingRules.includes(productSKU.id));
}
exports.hasShippingRuleInEveryProductSKUsBySelectedShippingId = hasShippingRuleInEveryProductSKUsBySelectedShippingId;
/**
 * @deprecated
 * Use hasShippingRuleInEveryProductSKUsBySelectedShippingId
 */
function hasShippingRuleInEveryProductSKUs(productSKUs, shippingRules, shippingMethod) {
    const productSKUIdsOfShippingRules = shippingRules
        .filter((shippingRule) => shippingRule.method === shippingMethod)
        .flatMap((shippingRule) => shippingRule.selectedProducts.map((selectedProduct) => selectedProduct.id));
    return productSKUs.every((productSKU) => productSKUIdsOfShippingRules.includes(productSKU.id));
}
exports.hasShippingRuleInEveryProductSKUs = hasShippingRuleInEveryProductSKUs;
/**
 * Is every remaining product skus has shipping rules
 * @param cart
 * @param productSKUs
 * @param shippingRules
 * @returns
 */
function isEveryProductSKUHasShippingRules(cart, productSKUs, shippingRules) {
    var _a;
    if (cart.selectedShipping && cart.selectedShipping.shippingId) {
        return hasShippingRuleInEveryProductSKUsBySelectedShippingId(productSKUs, shippingRules, cart.selectedShipping.shippingId);
    }
    // Backward compatible
    return hasShippingRuleInEveryProductSKUs(productSKUs, shippingRules, ((_a = cart.shipping) === null || _a === void 0 ? void 0 : _a.method) || typings_1.ShippingMethod.STANDARD);
}
exports.isEveryProductSKUHasShippingRules = isEveryProductSKUHasShippingRules;
function getAmountThresholdForUnitPriceShippingRule(settings) {
    const amountThreshold = settings.amountThreshold || 0;
    return amountThreshold > 0 ? amountThreshold : Math.ceil(settings.basePrice / settings.pricePerUnit);
}
exports.getAmountThresholdForUnitPriceShippingRule = getAmountThresholdForUnitPriceShippingRule;
function getFloatValueWithFixedDigit(value, digit = 2) {
    const valueWithFixedDigit = value.toFixed(digit);
    return parseFloat(valueWithFixedDigit);
}
exports.getFloatValueWithFixedDigit = getFloatValueWithFixedDigit;
function getRemainingProductSKU(productSKUs, selectedProductIds) {
    return productSKUs
        .map((productSKU) => {
        if (!selectedProductIds.includes(productSKU.id)) {
            return productSKU;
        }
        return undefined;
    })
        .filter(Boolean);
}
exports.getRemainingProductSKU = getRemainingProductSKU;
function getSelectedProductsWithSelectedProductIdsAndPromotionIds(productSKUs, selectedProductIds, promotionIds) {
    const productSKUIds = productSKUs.map((productSKU) => productSKU.id);
    return productSKUs
        .map((productSKU) => {
        var _a;
        if (selectedProductIds.includes(productSKU.id) || !selectedProductIds.length) {
            const matchedPromotions = (_a = productSKU.promotions) === null || _a === void 0 ? void 0 : _a.filter((promotion) => promotionIds.includes(promotion.id));
            if (matchedPromotions === null || matchedPromotions === void 0 ? void 0 : matchedPromotions.length) {
                return Object.assign(Object.assign({}, productSKU), { promotions: matchedPromotions.map((promotion) => (Object.assign(Object.assign({}, promotion), { selectedProducts: promotion.selectedProducts.filter((selectedProduct) => productSKUIds.includes(selectedProduct.id)) }))) });
            }
        }
        return undefined;
    })
        .filter(Boolean);
}
exports.getSelectedProductsWithSelectedProductIdsAndPromotionIds = getSelectedProductsWithSelectedProductIdsAndPromotionIds;
function getTotalAmount(productSKUs) {
    return productSKUs.reduce((totalAmount, productSKU) => {
        if (!productSKU.isFree) {
            return totalAmount + productSKU.amount;
        }
        return totalAmount + 0;
    }, 0);
}
exports.getTotalAmount = getTotalAmount;
function getTotalAmountOfSelectedProducts(productSKUs, selectedProductIds) {
    return productSKUs.reduce((totalAmount, productSKU) => {
        if (selectedProductIds.includes(productSKU.id) && !productSKU.isFree) {
            return totalAmount + productSKU.amount;
        }
        return totalAmount + 0;
    }, 0);
}
exports.getTotalAmountOfSelectedProducts = getTotalAmountOfSelectedProducts;
function getTotalPrice(productSKUs) {
    return productSKUs.reduce((totalPrice, productSKU) => {
        if (!productSKU.isFree) {
            return totalPrice + productSKU.amount * productSKU.price;
        }
        return totalPrice + 0;
    }, 0);
}
exports.getTotalPrice = getTotalPrice;
function getTotalWeight(productSKUs) {
    const sumProductsWeight = productSKUs.reduce((totalWeight, productSKU) => {
        const productSKUWeight = productSKU.weight;
        const productWeight = productSKU.product && productSKU.product.weight ? productSKU.product.weight : 0;
        const weight = productSKUWeight || productWeight || 0;
        return totalWeight + productSKU.amount * weight;
    }, 0);
    return parseFloatNumberWithDefaultDigit(sumProductsWeight);
}
exports.getTotalWeight = getTotalWeight;
function getTotalPriceOfSelectedProducts(productSKUs, selectedProductIds) {
    return productSKUs.reduce((totalPrice, productSKU) => {
        if (selectedProductIds.includes(productSKU.id) && !productSKU.isFree) {
            return totalPrice + productSKU.amount * productSKU.price;
        }
        return totalPrice + 0;
    }, 0);
}
exports.getTotalPriceOfSelectedProducts = getTotalPriceOfSelectedProducts;
function getTotalPriceIncludingDiscountOfSelectedProducts(productSKUs, selectedProductIds) {
    // eslint-disable-next-line functional/prefer-readonly-type
    const selectedProductSKUs = [];
    const totalPrice = productSKUs.reduce((accumulatedPrice, productSKU) => {
        if (selectedProductIds.includes(productSKU.id) && !productSKU.isFree) {
            selectedProductSKUs.push(productSKU);
            return accumulatedPrice + productSKU.amount * productSKU.price;
        }
        return accumulatedPrice;
    }, 0);
    const promotions = selectedProductSKUs.flatMap((selectedProductSKU) => selectedProductSKU.promotions || []);
    const uniqPromotions = (0, lodash_uniqby_1.default)(promotions, 'id');
    const totalDiscount = uniqPromotions.reduce((accumulatedDiscount, promotion) => {
        const discount = promotion.totalDiscount || 0;
        return accumulatedDiscount + discount;
    }, 0);
    return totalPrice - totalDiscount;
}
exports.getTotalPriceIncludingDiscountOfSelectedProducts = getTotalPriceIncludingDiscountOfSelectedProducts;
/**
 * Get unique shipping rules by selected shipping method
 * @deprecated
 * Use "getUniqueShippingRulesByShippingId"
 */
function getUniqueShippingRules(productSKUs, shippingMethod) {
    const shippingRules = productSKUs.flatMap((productSKU) => {
        const productSKUShippingRules = productSKU.shippingRules && productSKU.shippingRules.length ? productSKU.shippingRules : [];
        return productSKUShippingRules.filter((shippingRule) => shippingRule.method && shippingRule.method.toLowerCase() === shippingMethod.toLowerCase());
    });
    return (0, lodash_uniqby_1.default)(shippingRules, 'id');
}
exports.getUniqueShippingRules = getUniqueShippingRules;
/**
 * Get Unique shipping rules by selected shipping id
 * @param productSKUs
 * @param shippingId
 * @returns
 */
function getUniqueShippingRulesByShippingId(productSKUs, shippingId) {
    const shippingRules = productSKUs.flatMap((productSKU) => {
        const productSKUShippingRules = productSKU.shippingRules && productSKU.shippingRules.length ? productSKU.shippingRules : [];
        return productSKUShippingRules.filter((shippingRule) => {
            const shippingIds = shippingRule.shippingIds || [];
            return shippingIds.includes(shippingId);
        });
    });
    return (0, lodash_uniqby_1.default)(shippingRules, 'id');
}
exports.getUniqueShippingRulesByShippingId = getUniqueShippingRulesByShippingId;
/**
 * Get shipping rules of remaining product skus with backward compatible
 * @param cart
 * @param productSKUs
 * @returns
 */
function getShippingRulesOfProductSKUs(cart, productSKUs) {
    var _a;
    if (cart.selectedShipping && cart.selectedShipping.shippingId) {
        return getUniqueShippingRulesByShippingId(productSKUs, cart.selectedShipping.shippingId);
    }
    // Backward compatible
    return getUniqueShippingRules(productSKUs, ((_a = cart.shipping) === null || _a === void 0 ? void 0 : _a.method) || typings_1.ShippingMethod.STANDARD);
}
exports.getShippingRulesOfProductSKUs = getShippingRulesOfProductSKUs;
function mergeProductSKUsInformation(productSKUs, productSKUsWithAdditionalInformation) {
    return productSKUs.map((productSKU) => {
        const matchedProductSKU = productSKUsWithAdditionalInformation.find((productSKUWithAdditionalInformation) => productSKUWithAdditionalInformation.id === productSKU.id);
        if (matchedProductSKU) {
            return Object.assign(Object.assign({}, productSKU), matchedProductSKU);
        }
        return Object.assign({}, productSKU);
    });
}
exports.mergeProductSKUsInformation = mergeProductSKUsInformation;
function separateFreeablePromotionsAndOtherPromotions(promotions) {
    const freeablePromotions = promotions.filter((promotion) => FREEABLE_PROMOTIONS.includes(promotion.getPromotionSettingsType()));
    const nonFreeablePromotions = promotions.filter((promotion) => !FREEABLE_PROMOTIONS.includes(promotion.getPromotionSettingsType()));
    return [freeablePromotions, nonFreeablePromotions];
}
exports.separateFreeablePromotionsAndOtherPromotions = separateFreeablePromotionsAndOtherPromotions;
function separateShippingPromotionsAndOtherPromotions(promotions) {
    const shippingPromotions = promotions.filter((promotion) => promotion.getPromotionType() === typings_1.PromotionType.SHIPPING);
    const otherPromotions = promotions.filter((promotion) => promotion.getPromotionType() !== typings_1.PromotionType.SHIPPING);
    return [shippingPromotions, otherPromotions];
}
exports.separateShippingPromotionsAndOtherPromotions = separateShippingPromotionsAndOtherPromotions;
function sortCartByAwardFromLowToHigh(productSKUs, awardFromLowToHigh = true) {
    /**
     * Pass by value here by spreading values from read-only array
     * if use const sortedProductSKUs = productSKUs -> that will be
     * passed by reference which will mutate the original data
     */
    return [...productSKUs].sort((a, b) => (awardFromLowToHigh ? a.price - b.price : b.price - a.price));
}
exports.sortCartByAwardFromLowToHigh = sortCartByAwardFromLowToHigh;
function sortPromotionByPromotionPriority(promotions, direction = typings_1.SortDirection.ASC) {
    const sortedPromotions = [...promotions];
    if (direction === typings_1.SortDirection.ASC) {
        sortedPromotions.sort((first, second) => first.getPromotionPriority() - second.getPromotionPriority());
        return sortedPromotions;
    }
    sortedPromotions.sort((first, second) => second.getPromotionPriority() - first.getPromotionPriority());
    return sortedPromotions;
}
exports.sortPromotionByPromotionPriority = sortPromotionByPromotionPriority;
function sortPromotionsForApplyToCart(promotions) {
    const productPromotions = promotions.filter((promotion) => promotion.getPromotionType() === typings_1.PromotionType.PRODUCT);
    const nonFixedPricePromotions = productPromotions.filter((productPromotion) => productPromotion.getPromotionSettingsType() !== typings_1.PromotionSettingsType.FIXED_PRICE_DISCOUNT);
    const fixedPricePromotions = productPromotions.filter((productPromotion) => productPromotion.getPromotionSettingsType() === typings_1.PromotionSettingsType.FIXED_PRICE_DISCOUNT);
    const sortedFixedPricePromotions = sortPromotionByPromotionPriority(fixedPricePromotions);
    const freeShippingPromotions = promotions.filter((promotion) => promotion.getPromotionType() === typings_1.PromotionType.SHIPPING &&
        promotion.getPromotionSettingsType() === typings_1.PromotionSettingsType.FREE_SHIPPING);
    const shippingPromotionsWithoutFreeShipping = promotions.filter((promotion) => promotion.getPromotionType() === typings_1.PromotionType.SHIPPING &&
        promotion.getPromotionSettingsType() !== typings_1.PromotionSettingsType.FREE_SHIPPING);
    const nonPercentageDiscountShippingPromotions = shippingPromotionsWithoutFreeShipping.filter((shippingPromotion) => shippingPromotion.getPromotionType() === typings_1.PromotionType.SHIPPING &&
        shippingPromotion.getPromotionSettingsType() !== typings_1.PromotionSettingsType.PERCENTAGE_DISCOUNT);
    const percentageDiscountShippingPromotions = shippingPromotionsWithoutFreeShipping.filter((shippingPromotion) => shippingPromotion.getPromotionType() === typings_1.PromotionType.SHIPPING &&
        shippingPromotion.getPromotionSettingsType() === typings_1.PromotionSettingsType.PERCENTAGE_DISCOUNT);
    const otherShippingPromotions = [...nonPercentageDiscountShippingPromotions, ...percentageDiscountShippingPromotions];
    return [
        ...sortedFixedPricePromotions,
        ...nonFixedPricePromotions,
        ...otherShippingPromotions,
        ...freeShippingPromotions,
    ];
}
exports.sortPromotionsForApplyToCart = sortPromotionsForApplyToCart;
function getTotalSelectedOptionsPrice(options) {
    if (!options || !options.length) {
        return 0;
    }
    const selectedOptionPrices = options
        .filter((option) => option.isActive)
        .flatMap((option) => option.choices.map((choice) => (choice.isSelected && choice.isActive ? choice.price : 0)));
    return selectedOptionPrices.reduce((selectedOptionPrice, price) => price + selectedOptionPrice, 0);
}
exports.getTotalSelectedOptionsPrice = getTotalSelectedOptionsPrice;
function getSerializeCartProducts(productSKUs) {
    return productSKUs
        .map((productSKU) => {
        var _a;
        return ({
            amount: Number(productSKU.amount),
            isAddedByAdmin: Boolean(productSKU.isAddedByAdmin),
            isFree: Boolean(productSKU.isFree),
            note: productSKU.note,
            options: productSKU.options,
            productCode: productSKU.productCode,
            productId: Number((_a = productSKU.product) === null || _a === void 0 ? void 0 : _a.id),
            productPrice: Number(productSKU.price),
            productSKUId: Number(productSKU.id),
            productSKUStock: Number(productSKU.stock),
        });
    })
        .filter(Boolean);
}
exports.getSerializeCartProducts = getSerializeCartProducts;
function getSerializeOrderProducts(productSKUs) {
    return productSKUs.map((productSKU) => {
        var _a;
        return ({
            amount: Number(productSKU.amount),
            isAddedByAdmin: Boolean(productSKU.isAddedByAdmin),
            isFree: Boolean(productSKU.isFree),
            note: productSKU.note,
            options: productSKU.options,
            product: productSKU.product,
            productId: Number((_a = productSKU.product) === null || _a === void 0 ? void 0 : _a.id),
            productPrice: Number(productSKU.price),
            productSKU: Object.assign(Object.assign({}, productSKU), { product: undefined, promotions: [] }),
            productSKUId: Number(productSKU.id),
        });
    });
}
exports.getSerializeOrderProducts = getSerializeOrderProducts;
function calculateDiscount(multiplier, discount, totalPriceOfProductSKU) {
    const promotionDiscount = discount * multiplier;
    if (totalPriceOfProductSKU - promotionDiscount >= 0) {
        return promotionDiscount;
    }
    return totalPriceOfProductSKU;
}
exports.calculateDiscount = calculateDiscount;
function sortPromotionsByPriorityFromHightToLow(promotions) {
    return [...promotions].sort((a, b) => a.getPromotionPriority() - b.getPromotionPriority());
}
exports.sortPromotionsByPriorityFromHightToLow = sortPromotionsByPriorityFromHightToLow;
function getNumberInRange(min, max, input) {
    if (input < max) {
        return Math.max(input, min); // using Max to handle input with negative number
    }
    return max;
}
exports.getNumberInRange = getNumberInRange;
function getHighestPriorityPromotionByPromotionSettingsType(promotions, promotionType) {
    if (!promotions || !promotions.length) {
        return undefined;
    }
    const filteredPromotions = promotions.filter((promotion) => promotion.getPromotionSettingsType() === promotionType);
    const sortedPromotions = sortPromotionsByPriorityFromHightToLow(filteredPromotions);
    if (!sortedPromotions.length) {
        return undefined;
    }
    return sortedPromotions[0];
}
exports.getHighestPriorityPromotionByPromotionSettingsType = getHighestPriorityPromotionByPromotionSettingsType;
function filterDuplicatedPromotionsByPromotionSettingsType(promotions, promotionType) {
    if (!promotions || !promotions.length) {
        return [];
    }
    const highestPriorityPromotion = getHighestPriorityPromotionByPromotionSettingsType(promotions, promotionType);
    if (highestPriorityPromotion) {
        const otherPromotions = promotions.filter((promotion) => promotion.getPromotionSettingsType() !== promotionType);
        return [...otherPromotions, highestPriorityPromotion];
    }
    return promotions;
}
exports.filterDuplicatedPromotionsByPromotionSettingsType = filterDuplicatedPromotionsByPromotionSettingsType;
function hasSomeXTypeProductSKUs(productSKUs, type) {
    if (!productSKUs || !productSKUs.length) {
        return false;
    }
    return productSKUs.some((productSKU) => {
        if (!productSKU || !productSKU.product) {
            return false;
        }
        return productSKU.product.type === type;
    });
}
exports.hasSomeXTypeProductSKUs = hasSomeXTypeProductSKUs;
function hasAllXTypeProductSKUs(productSKUs, type) {
    if (!productSKUs || !productSKUs.length) {
        return false;
    }
    return productSKUs.every((productSKU) => {
        if (!productSKU || !productSKU.product) {
            return false;
        }
        return productSKU.product.type === type;
    });
}
exports.hasAllXTypeProductSKUs = hasAllXTypeProductSKUs;
function hasOnlyXTypeProducts(productSKUs, productType) {
    if (!productSKUs || !productSKUs.length) {
        return false;
    }
    return hasAllXTypeProductSKUs(productSKUs, productType);
}
exports.hasOnlyXTypeProducts = hasOnlyXTypeProducts;
function hasBothDigitalAndSKUProducts(productSKUs) {
    if (!productSKUs || !productSKUs.length) {
        return false;
    }
    return (hasSomeXTypeProductSKUs(productSKUs, typings_1.ProductType.SKU) &&
        hasSomeXTypeProductSKUs(productSKUs, typings_1.ProductType.DIGITAL_CONTENT));
}
exports.hasBothDigitalAndSKUProducts = hasBothDigitalAndSKUProducts;
function getLargestDimension(productSKUs) {
    return productSKUs.reduce((largestDimension, productSKU) => {
        var _a, _b;
        if (!productSKU.dimension && !((_a = productSKU.product) === null || _a === void 0 ? void 0 : _a.dimension)) {
            return largestDimension;
        }
        const productDimension = productSKU.dimension ? productSKU.dimension : (_b = productSKU.product) === null || _b === void 0 ? void 0 : _b.dimension;
        if (!productDimension) {
            return largestDimension;
        }
        const [previousWidth, previousHeight, previousDepth] = largestDimension;
        const [width, height, depth] = productDimension;
        const newWidth = Math.max(previousWidth, width);
        const newHeight = Math.max(previousHeight, height);
        const newDepth = Math.max(previousDepth, depth);
        return [newWidth, newHeight, newDepth];
    }, [0, 0, 0]);
}
exports.getLargestDimension = getLargestDimension;
function getPromotionThreshold(threshold) {
    if (isNotNullAndUndefined(threshold === null || threshold === void 0 ? void 0 : threshold.price)) {
        return threshold.price;
    }
    return threshold === null || threshold === void 0 ? void 0 : threshold.amount;
}
exports.getPromotionThreshold = getPromotionThreshold;
function getPromotionDiscountCriteria(criteria) {
    if (isUndefined(criteria.discount)) {
        return undefined;
    }
    const discountCriteria = criteria.discount;
    if (isNotNullAndUndefined(discountCriteria.amount)) {
        return discountCriteria.amount;
    }
    if (isNotNullAndUndefined(discountCriteria.fixed)) {
        return discountCriteria.fixed;
    }
    return discountCriteria.percent;
}
exports.getPromotionDiscountCriteria = getPromotionDiscountCriteria;
function sortedPromotionCriteria(promotionCriteria) {
    if (!promotionCriteria.length) {
        return [];
    }
    const sortedPromotionCriteriaThreshold = promotionCriteria.map((criteria) => {
        const thresholds = [...criteria.thresholds].sort((a, b) => {
            const firstThreshold = (a === null || a === void 0 ? void 0 : a.amount) || (a === null || a === void 0 ? void 0 : a.price);
            const secondThreshold = (b === null || b === void 0 ? void 0 : b.amount) || (b === null || b === void 0 ? void 0 : b.price);
            return firstThreshold - secondThreshold;
        });
        return Object.assign(Object.assign({}, criteria), { thresholds, minimumThreshold: getPromotionThreshold(thresholds[0]), maximumThreshold: getPromotionThreshold(thresholds[thresholds.length - 1]) });
    });
    return sortedPromotionCriteriaThreshold.sort((firstCriteria, secondCriteria) => {
        const minimumThresholdOfFirstCriteria = (firstCriteria === null || firstCriteria === void 0 ? void 0 : firstCriteria.minimumThreshold) || Number.MAX_SAFE_INTEGER;
        const minimumThresholdOfSecondCriteria = (secondCriteria === null || secondCriteria === void 0 ? void 0 : secondCriteria.minimumThreshold) || Number.MAX_SAFE_INTEGER;
        const sortingResult = minimumThresholdOfFirstCriteria - minimumThresholdOfSecondCriteria;
        if (sortingResult !== 0) {
            return sortingResult;
        }
        if (firstCriteria.thresholds.length === 1) {
            return -1;
        }
        const maximumThresholdOfFirstCriteria = firstCriteria.maximumThreshold || Number.MAX_SAFE_INTEGER;
        const maximumThresholdOfSecondCriteria = secondCriteria.maximumThreshold || Number.MAX_SAFE_INTEGER;
        return maximumThresholdOfFirstCriteria - maximumThresholdOfSecondCriteria;
    });
}
exports.sortedPromotionCriteria = sortedPromotionCriteria;
function isIncorrectCriteriaThreshold(criteria) {
    if (!criteria.operator) {
        return false;
    }
    const atLeastOrEqualCriteriaOperator = [typings_1.PromotionOperator.AT_LEAST, typings_1.PromotionOperator.EQUAL].includes(criteria.operator);
    const betweenCriteriaOperator = criteria.operator === typings_1.PromotionOperator.BETWEEN;
    const thresholdLength = criteria.thresholds.length;
    const isIncorrectFormatForAtLeastAndEqualCriteriaOperator = atLeastOrEqualCriteriaOperator && thresholdLength !== 1;
    const isIncorrectFormatForBetweenCriteriaOperator = betweenCriteriaOperator && thresholdLength !== 2;
    return isIncorrectFormatForAtLeastAndEqualCriteriaOperator || isIncorrectFormatForBetweenCriteriaOperator;
}
function isOverlappedWithAtLeastCriteria(atLeastCriteria, criteria) {
    const minimumAtLeastCriteriaThreshold = atLeastCriteria.minimumThreshold;
    const minimumCurrentThreshold = criteria.minimumThreshold;
    const maximumCurrentThreshold = criteria.maximumThreshold;
    if (minimumAtLeastCriteriaThreshold === undefined ||
        minimumCurrentThreshold === undefined ||
        maximumCurrentThreshold === undefined) {
        return false;
    }
    return (minimumAtLeastCriteriaThreshold <= minimumCurrentThreshold ||
        minimumAtLeastCriteriaThreshold <= maximumCurrentThreshold);
}
function validatePromotionCriteria(promotionCriteria) {
    if (!promotionCriteria.length) {
        return [];
    }
    const sortedCriteria = sortedPromotionCriteria(promotionCriteria);
    const atLeastCriteriaIndex = sortedCriteria.findIndex((criteria) => criteria.operator === typings_1.PromotionOperator.AT_LEAST);
    return sortedCriteria.map((criteria, index, allCriteria) => {
        if (isIncorrectCriteriaThreshold(criteria)) {
            throw new errors_1.PromotionCriteriaError('INCORRECT_THRESHOLD_CRITERIA', [criteria]);
        }
        const atLeastCriteria = allCriteria[atLeastCriteriaIndex];
        if (index !== atLeastCriteriaIndex && atLeastCriteria) {
            if (isOverlappedWithAtLeastCriteria(atLeastCriteria, criteria)) {
                throw new errors_1.PromotionCriteriaError('OVERLAPPED_CRITERIA', [criteria, atLeastCriteria]);
            }
        }
        if (criteria.thresholds.length) {
            const nextCriteria = allCriteria[index + 1];
            if (nextCriteria && criteria.maximumThreshold) {
                const maximumCurrentThreshold = criteria.maximumThreshold || 0;
                const minimumNextThreshold = nextCriteria.minimumThreshold || 0;
                if (maximumCurrentThreshold === minimumNextThreshold) {
                    throw new errors_1.PromotionCriteriaError('OVERLAPPED_CRITERIA', [criteria, nextCriteria]);
                }
            }
        }
        return criteria;
    });
}
exports.validatePromotionCriteria = validatePromotionCriteria;
function getPromotionCriteriaByPromotionSetting(promotion) {
    const promotionSettings = promotion.getPromotionSettings();
    if (promotionSettings === null || promotionSettings === void 0 ? void 0 : promotionSettings.criteria) {
        return promotionSettings === null || promotionSettings === void 0 ? void 0 : promotionSettings.criteria;
    }
    const { condition, discount, threshold } = promotionSettings;
    const freeProducts = promotion.getPromotionFreeProducts();
    if (condition === typings_1.PromotionCondition.BUY_ANY_PRODUCT) {
        return [
            {
                discount,
                freeProducts,
                thresholds: [threshold].filter(Boolean),
            },
        ];
    }
    return [
        {
            discount,
            freeProducts,
            operator: typings_1.PromotionOperator.AT_LEAST,
            thresholds: [threshold].filter(Boolean),
        },
    ];
}
exports.getPromotionCriteriaByPromotionSetting = getPromotionCriteriaByPromotionSetting;
function getMultiplierByPromotionCriteriaAndDividend(criteria, dividend, isAutoGeneratedCriteria = false, isRepeatable = true) {
    if (!isAutoGeneratedCriteria) {
        return 1;
    }
    if (!isRepeatable) {
        return 1;
    }
    return Math.floor(dividend / getPromotionThreshold(criteria.thresholds[0]));
}
exports.getMultiplierByPromotionCriteriaAndDividend = getMultiplierByPromotionCriteriaAndDividend;
function calculateDiscountableAmount(multiplier, totalPriceOfProductSKUs, discount) {
    const promotionDiscount = discount * multiplier;
    if (totalPriceOfProductSKUs - promotionDiscount >= 0) {
        return promotionDiscount;
    }
    return totalPriceOfProductSKUs;
}
exports.calculateDiscountableAmount = calculateDiscountableAmount;
function isMetThresholdCriteria(criteria, target) {
    if (!criteria.thresholds.length || !criteria.operator) {
        return true;
    }
    if (criteria.operator === typings_1.PromotionOperator.AT_LEAST) {
        const atLeastThreshold = getPromotionThreshold(criteria.thresholds[0]);
        return target >= atLeastThreshold;
    }
    if (criteria.operator === typings_1.PromotionOperator.BETWEEN) {
        const firstThreshold = getPromotionThreshold(criteria.thresholds[0]);
        const secondThreshold = getPromotionThreshold(criteria.thresholds[1]);
        return target >= firstThreshold && target <= secondThreshold;
    }
    const threshold = getPromotionThreshold(criteria.thresholds[0]);
    return target === threshold;
}
exports.isMetThresholdCriteria = isMetThresholdCriteria;
function isMetThresholdCriteriaExactly(criteria, target) {
    if (!criteria.thresholds.length || !criteria.operator) {
        return true;
    }
    const threshold = getPromotionThreshold(criteria.thresholds[0]);
    return target === threshold;
}
exports.isMetThresholdCriteriaExactly = isMetThresholdCriteriaExactly;
function getThresholdAmountFromCriteria(criteria) {
    if (!criteria.thresholds.length || !criteria.operator) {
        return 0;
    }
    if ([typings_1.PromotionOperator.AT_LEAST, typings_1.PromotionOperator.EQUAL].includes(criteria.operator)) {
        return getPromotionThreshold(criteria.thresholds[0]);
    }
    const firstThreshold = getPromotionThreshold(criteria.thresholds[0]);
    const secondThreshold = getPromotionThreshold(criteria.thresholds[1]);
    return Math.max(firstThreshold, secondThreshold);
}
exports.getThresholdAmountFromCriteria = getThresholdAmountFromCriteria;
function normalizeFreeProducts(freeProducts) {
    return freeProducts.reduce((normalizedFreeProducts, freeProduct) => {
        const sameFreeProducts = normalizedFreeProducts.filter((normalizedFreeProduct) => normalizedFreeProduct.id === freeProduct.id);
        if (!sameFreeProducts.length) {
            return normalizedFreeProducts.concat(freeProduct);
        }
        return normalizedFreeProducts.map((normalizedFreeProduct) => {
            if (normalizedFreeProduct.id !== freeProduct.id) {
                return normalizedFreeProduct;
            }
            return Object.assign(Object.assign({}, normalizedFreeProduct), { amount: normalizedFreeProduct.amount + freeProduct.amount });
        });
    }, []);
}
exports.normalizeFreeProducts = normalizeFreeProducts;
function getLargestProductSKU(productSKUs, selectedProductIds) {
    const selectedProductSKUs = productSKUs.filter((productSKU) => selectedProductIds.includes(productSKU.id));
    if (!selectedProductSKUs.length) {
        return undefined;
    }
    if (selectedProductSKUs.length === 1) {
        return selectedProductSKUs[0];
    }
    const sortedLargestProductSKUsByAmount = selectedProductSKUs.sort((firstProductSKU, secondProductSKU) => secondProductSKU.amount - firstProductSKU.amount);
    return sortedLargestProductSKUsByAmount[0];
}
exports.getLargestProductSKU = getLargestProductSKU;
/**
 * Is matched selected shipping by chosen shipping ids and selected shipping id
 *
 * ** Note **
 *
 * This function has been reused between "base-promotion" and "base-shipping-rule" as
 * both of them require to check for match shipping
 */
function isMatchedSelectedShippingByChosenShippingIdsAndSelectedShippingId(cart, chosenShippingIds) {
    var _a, _b, _c;
    /**
     * Always return true if this flag is being marked as "true"
     * This usually uses to show all possible shipping promotion for customer
     * before they select their shipping
     */
    if (cart.isAppliedToAllShipping) {
        return true;
    }
    /**
     * If selected shipping type is undefined or selected shipping type is either
     * "DIGITAL" or "PICKUP", system should simply return false in every case
     * as "DIGITAL" or "PICKUP" should not be included for any shipping promotions
     */
    if (!((_a = cart.selectedShipping) === null || _a === void 0 ? void 0 : _a.type) ||
        [typings_1.ShippingInformationType.DIGITAL, typings_1.ShippingInformationType.PICKUP].includes((_b = cart.selectedShipping) === null || _b === void 0 ? void 0 : _b.type)) {
        return false;
    }
    const selectedShippingId = (_c = cart.selectedShipping) === null || _c === void 0 ? void 0 : _c.shippingId;
    if (!selectedShippingId) {
        return false;
    }
    return chosenShippingIds.includes(selectedShippingId);
}
exports.isMatchedSelectedShippingByChosenShippingIdsAndSelectedShippingId = isMatchedSelectedShippingByChosenShippingIdsAndSelectedShippingId;
/**
 * Is matched selected shipping method by chosen shipping method
 * @deprecated
 * Use isMatchedSelectedShippingByChosenShippingIdsAndSelectedShippingId
 */
function isMatchedSelectedShippingByChosenShippingMethod(cart, chosenShippingMethod) {
    var _a;
    if (!chosenShippingMethod) {
        return false;
    }
    const shippingMethod = (_a = cart.shipping) === null || _a === void 0 ? void 0 : _a.method;
    if (chosenShippingMethod === typings_1.ShippingMethod.ALL || shippingMethod === typings_1.ShippingMethod.ALL) {
        return true;
    }
    return chosenShippingMethod === shippingMethod;
}
exports.isMatchedSelectedShippingByChosenShippingMethod = isMatchedSelectedShippingByChosenShippingMethod;
function getMaximumShippingDuration(duration) {
    if (!duration || !duration.isActive) {
        return 0;
    }
    return Math.max(duration.min || 0, duration.max || 0);
}
exports.getMaximumShippingDuration = getMaximumShippingDuration;
//# sourceMappingURL=index.js.map